<template>
  <Row
    class="capsule-tab-wrapper"
    type="flex"
    justify="space-between"
  >
    <Col
      :span="8"
      :class="{'capsule-tab-item': true, 'active': selected==1, 'first-item': true}"
      @click="handleCheck(1)"
    >上周</Col>
    <Col
      :span="8"
      :class="{'capsule-tab-item': true, 'active': selected==2, 'second-item': true}"
      @click="handleCheck(2)"
    >本月</Col>
    <Col
      :span="8"
      :class="{'capsule-tab-item': true, 'active': selected==3, 'third-item': true}"
      @click="handleCheck(3)"
    >总榜</Col>
  </Row>
</template>

<script>
import { Row, Col } from 'vant'
export default {
  name: 'CapsuleTab',
  components: { Row, Col },
  props: {
    selected: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    handleCheck (index) {
      this.$emit('change', index)
    }
  }
}
</script>

<style lang="less">
.capsule-tab{
  &-wrapper{
    box-sizing: border-box;
    position: relative;
    width: 195px;
    margin: 0 auto;
    border-radius: 19px;
    border: 1Px solid #70768f;
  }
  &-item{
    box-sizing: border-box;
    background-color: #F8F9FC;
    color: #70768f;
    text-align: center;
    font-size: 15px;
    padding: 3px 0;
    border-radius: 18px;
    &.active{
      box-sizing: border-box;
      background-color: #70768f;
      color: #F8F9FC;
      border-radius: 16px;
      z-index: 1;
    }
    &.second-item{
      position: absolute;
      left: 64px;
    }
    &.third-item{
      position: absolute;
      right: 0;
    }
  }
}
</style>
